import { TipsMessageBox } from './TipsMessageBox'
export default TipsMessageBox